import React, {useMemo} from 'react'

import {useMapComponents} from '../../hooks'
import {MapClustererProps as Props} from '../../types'

export default function MapClusterer({gridSize = 64, ...props}: Props): React.ReactElement<Props> | null {
  const mapContext = useMapComponents()

  const {clusterByGrid, YMapClusterer} = mapContext || {}
  const gridSizedMethod = useMemo(() => clusterByGrid?.({gridSize}), [clusterByGrid, gridSize])

  if (!mapContext) {
    return null
  }

  // @ts-expect-error у наших компонентов нет обертки <YMapEntity />
  return <YMapClusterer method={gridSizedMethod} {...props} />
}
